import { FC, useMemo } from "react";
import type SwiperCore from "swiper";
import useWindowSize from "apps/website/hooks/useWindowSize";
import { Gender } from "@./cat-calculations";
import { RecipesForCatResponse } from "libs/forms-schema/src/action-types";

import { RecipesCarousel } from "../Carousel/RecipesCarousel/RecipesCarousel";
import Grid from "../../layout/Grid/Grid";
import Column from "../../layout/Column/Column";

import { useTransformRecipesToCards } from "./useRecipeListTransformer";
import { RecipeCard } from "./RecipeCard/RecipeCard";

export interface IRecipeListProps {
  recipes: RecipesForCatResponse
  catName: string;
  gender: Gender;
  onSwiperInit?: (swiper: SwiperCore) => void;
}

export const RecipeList: FC<IRecipeListProps> = ({ recipes, catName, gender, onSwiperInit }) => {
  const { isActiveBreakpointAbove } = useWindowSize();

  const isDesktop = isActiveBreakpointAbove("lg");

  const transformedRecipes = useTransformRecipesToCards({
    recipes,
    catName,
    gender,
  });

  const chosenRecipes = useMemo(() => (
    transformedRecipes.filter((recipe) => (recipe.quantity || 0) > 0)
  ), [ transformedRecipes ]);

  return (
    <div data-component={RecipeList.name}>
      { isDesktop ? (
        <Grid gap="lg" className="h-full" data-testid="recipe-list">
          { chosenRecipes.map((recipe) => (
            <Column key={recipe.titleTag.label} spans={6}>
              <RecipeCard {...recipe} />
            </Column>
          )) }
        </Grid>
      ) : (
        <RecipesCarousel recipes={chosenRecipes} onSwiperInit={onSwiperInit} />
      ) }
    </div>
  );
};
